import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="chat-assistant"
var _default = /*#__PURE__*/function (_Controller) {
  function _default() {
    _classCallCheck(this, _default);
    return _callSuper(this, _default, arguments);
  }
  _inherits(_default, _Controller);
  return _createClass(_default, [{
    key: "connect",
    value: function connect() {
      this.history = [];
    }

    // ----------------------------------------------------------------
    // Actions
    // ----------------------------------------------------------------
  }, {
    key: "submit",
    value: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var text, indicator, data, reply;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              text = this.inputTarget.value.trim();
              if (text) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              this.inputTarget.value = '';
              this.setDisabled(true);
              this.appendMessage('user', text);
              this.history.push({
                role: 'user',
                content: text
              });
              indicator = this.appendTypingIndicator();
              _context.prev = 9;
              _context.next = 12;
              return this.postMessage(this.history);
            case 12:
              data = _context.sent;
              reply = data.reply || '(no response)';
              this.appendMessage('assistant', reply);
              this.history.push({
                role: 'assistant',
                content: reply
              });
              this.updateDebugLog(data.tool_calls);
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](9);
              this.appendMessage('assistant', "Error: ".concat(_context.t0.message));
            case 22:
              _context.prev = 22;
              indicator.remove();
              this.setDisabled(false);
              this.inputTarget.focus();
              return _context.finish(22);
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[9, 19, 22, 27]]);
      }));
      function submit(_x) {
        return _submit.apply(this, arguments);
      }
      return submit;
    }()
  }, {
    key: "clear",
    value: function clear() {
      this.history = [];
      this.windowTarget.innerHTML = '<div class="text-muted text-center small pt-4" data-chat-assistant-target="emptyState">' + 'Ask me to summarize a project or find consultants.<br>' + '<span class="text-secondary">e.g. "Find senior oncology consultants in Boston"</span>' + '</div>';
      this.debugLogTarget.innerHTML = '';
      this.debugEmptyTarget.style.display = '';
    }

    // ----------------------------------------------------------------
    // Rendering
    // ----------------------------------------------------------------
  }, {
    key: "appendMessage",
    value: function appendMessage(role, text) {
      if (this.hasEmptyStateTarget) this.emptyStateTarget.remove();
      var wrapper = document.createElement('div');
      wrapper.style.cssText = "display:flex;".concat(role === 'user' ? 'justify-content:flex-end;' : 'justify-content:flex-start;');
      var bubble = document.createElement('div');
      bubble.style.cssText = ['max-width:75%', 'padding:10px 14px', 'border-radius:14px', 'font-size:0.9rem', 'line-height:1.5', role === 'user' ? 'background:#0d6efd;color:#fff;border-bottom-right-radius:3px' : 'background:#f0f0f0;color:#212529;border-bottom-left-radius:3px'].join(';');
      bubble.innerHTML = this.markdownToHtml(text);
      wrapper.appendChild(bubble);
      this.windowTarget.appendChild(wrapper);
      this.windowTarget.scrollTop = this.windowTarget.scrollHeight;
    }
  }, {
    key: "appendTypingIndicator",
    value: function appendTypingIndicator() {
      var el = document.createElement('div');
      el.style.cssText = 'display:flex;justify-content:flex-start;';
      el.innerHTML = '<div style="background:#f0f0f0;padding:10px 14px;border-radius:14px;' + 'border-bottom-left-radius:3px;font-size:0.9rem;color:#555;">' + '<span class="spinner-border spinner-border-sm me-2" role="status"></span>Thinking…</div>';
      this.windowTarget.appendChild(el);
      this.windowTarget.scrollTop = this.windowTarget.scrollHeight;
      return el;
    }
  }, {
    key: "updateDebugLog",
    value: function updateDebugLog(toolCalls) {
      var _this = this;
      if (!toolCalls || toolCalls.length === 0) return;
      this.debugEmptyTarget.style.display = 'none';
      toolCalls.forEach(function (tc) {
        var line = document.createElement('div');
        line.className = 'mb-2 p-2 border rounded bg-white';
        line.innerHTML = "<strong>".concat(_this.escHtml(tc.tool), "</strong><br>") + "<span class=\"text-muted\">Input:</span> ".concat(_this.escHtml(JSON.stringify(tc.input)), "<br>") + "<span class=\"text-muted\">Result:</span> ".concat(_this.escHtml(tc.result_summary || ''));
        _this.debugLogTarget.appendChild(line);
      });
    }

    // ----------------------------------------------------------------
    // Network
    // ----------------------------------------------------------------
  }, {
    key: "postMessage",
    value: function () {
      var _postMessage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(messages) {
        var csrf, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
              _context2.next = 3;
              return fetch(this.messageUrlValue, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-CSRF-Token': csrf
                },
                body: JSON.stringify({
                  messages: messages
                })
              });
            case 3:
              res = _context2.sent;
              if (res.ok) {
                _context2.next = 6;
                break;
              }
              throw new Error("Server error ".concat(res.status));
            case 6:
              return _context2.abrupt("return", res.json());
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function postMessage(_x2) {
        return _postMessage.apply(this, arguments);
      }
      return postMessage;
    }() // ----------------------------------------------------------------
    // Helpers
    // ----------------------------------------------------------------
  }, {
    key: "setDisabled",
    value: function setDisabled(disabled) {
      this.sendBtnTarget.disabled = disabled;
      this.inputTarget.disabled = disabled;
      this.clearBtnTarget.disabled = disabled;
    }
  }, {
    key: "markdownToHtml",
    value: function markdownToHtml(text) {
      var escaped = String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      var formatInline = function formatInline(line) {
        return line.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>').replace(/`([^`]+)`/g, '<code>$1</code>');
      };
      var lines = escaped.split('\n');
      var html = '';
      var inList = false;
      for (var i = 0; i < lines.length; i += 1) {
        var line = lines[i];
        var listMatch = line.match(/^[-*] (.+)$/);
        if (listMatch) {
          if (!inList) {
            html += '<ul style="padding-left:1.2rem;margin:4px 0">';
            inList = true;
          }
          html += "<li>".concat(formatInline(listMatch[1]), "</li>");
        } else {
          if (inList) {
            html += '</ul>';
            inList = false;
          } else if (i > 0) {
            html += '<br>';
          }
          html += formatInline(line);
        }
      }
      if (inList) html += '</ul>';
      return html;
    }
  }, {
    key: "escHtml",
    value: function escHtml(str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
  }]);
}(Controller);
_defineProperty(_default, "targets", ['window', 'form', 'input', 'sendBtn', 'clearBtn', 'emptyState', 'debugLog', 'debugEmpty']);
_defineProperty(_default, "values", {
  messageUrl: String
});
export { _default as default };